import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Typography } from '@mui/material';
import type React from 'react';

interface Props {
  onComplete: () => void;
  onBack: () => void;
}

const ProcurementStep3Complete: React.FC<Props> = ({ onComplete, onBack }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        maxWidth: 600,
        mx: 'auto',
        textAlign: 'center',
        mt: 4,
      }}
    >
      <CheckCircleIcon color="success" sx={{ fontSize: 80, mx: 'auto' }} />

      <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
        You're All Set!
      </Typography>

      <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
        Your account is fully configured for the Procurement Ecosystem. Click below to enter your
        dashboard and begin managing your evaluations.
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        <Button variant="text" color="inherit" onClick={onBack} size="large">
          Back
        </Button>
        <Button variant="contained" color="primary" onClick={onComplete} size="large">
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
};

export default ProcurementStep3Complete;
